export const ugovor_o_stipendiranju= {
    templateId: 211,
    category: 15,
    templateTitle: 'Ugovor o stipendiranju studenta',
    templateDescription: `<p>Ugovorom o stipendiranju studenta reguliraju se prava i obveze davatelja stipendije (pravne ili fizičke osobe koja obavlja registriranu djelatnost) te primatelja stipendije (redovitog studenta). Stipendije se smatraju primitkom na koji se ne plaća dohodak (neoporezivi primitak), do ukupnog iznosa od 1.750,00 kn mjesečno. </p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    
    <p>Stipendije učenicima i studentima za redovno školovanje u tuzemstvu i inozemstvu na srednjim, višim i visokim školama te fakultetima trenutno se smatraju primitkom na koji se ne plaća dohodak (neoporezivi primitak), do iznosa ukupno do 1.750,00 kn mjesečno, a sukladno Zakonu o porezu na dohodak i Pravilniku o porezu na dohodak.</p>
    <p>Nastavak ovog teksta, kao i predložak dokumenta u nastavku odnosi se na isplate stipendija redovitim studentima koje čine izravno, bez javnog natječaja, sve pravne i fizičke osobe koje obavljaju registriranu djelatnost.</p>
    <p>Osim kod redovitog školovanja studenata na preddiplomskim, diplomskim ili integriranim preddiplomskim i diplomskim sveučilišnim studijima, odnosno preddiplomskim ili specijalističkim diplomskim stručnim studijima,  neoporezive stipendije dopuštene su i kod redovitog školovanja učenika u srednjim školama.</p>
    <p>Ipak, ne postoji ograničenje iznosa stipendije koju je moguće isplatiti učeniku/studentu, ali je na dio stipendije koji prelazi navedeni neoporezivi iznos (1.750,00 kn mjesečno) potrebno obračunati porez i prirez.</p>
    <p>Važno je napomenuti da su iznosi stipendija koji prelaze porezno priznate limite (1.750,00 kn mjesečno) oslobođeni obračuna doprinosa.</p>
    <p>Također, pravna ili fizička osoba može isplatiti neograničeni broj pojedinačnih stipendija različitim studentima.</p>
    <p>Stipendiju je moguće isplatiti redovitim učenicima srednjih škola i studentima,  iz čega proizlazi da je potrebno status redovitog učenika ili studenta dokumentirati potvrdom škole ili fakulteta.  </p>
    <p>Učenik ili student čiji ukupan iznos isplaćenih stipendija prelazi propisani neoporezivi iznos (1.750,00 kn mjesečno), obvezan je isplatitelju prije isplate stipendije dostaviti vjerodostojne isprave (preslike) ili pisanu izjavu o isplaćenim primicima po toj osnovi od drugih isplatitelja. </p>
    <p>Ako učenik ili student ostvaruje stipendiju samo od jednog isplatitelja, obvezan je tom isplatitelju dati pisanu izjavu da ne prima stipendije i od drugih isplatitelja.</p>
    <p>Stipendije se isplaćuju na temelju ugovora davatelja stipendije s primateljem ili na temelju odluke davatelja stipendije, no svakako se predlaže radi boljeg reguliranja međusobnih prava i obveza zaključiti poseban ugovor, čiji predložak se daje u nastavku. </p>
    <p>Isplatu stipendije nije moguće obaviti u gotovini, nego je nužno stipendiju isplatiti na tekući ili žiro račun stipendiste.</p>
    <p>Predloškom dokumenta u nastavku regulira se stipendija redovitog studenta, a predložak ugovora o stipendiranju redovitog učenika uz pripadajući uvodni tekst možete pogledati <a class="local-link" href="/contract?template=211">ovdje</a>. </p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak, Zakon o obveznim odnosima.</p>
  `,
  sides: [
    {
        signature: 'Davatelj stipendije',
        inputs: [{
            type: "input",
            required: true,
            placeholder: "Poslovni subjekt",
          },
          {
            type: "input",
            required: true,
            placeholder: "Ulica i kućni broj",
          },
          {
            type: "input",
            required: true,
            placeholder: "Mjesto",
          },
          {
            type: "input",
            required: true,
            placeholder: "OIB",
          },
          {
            type: "input",
            placeholder: "Zastupa",
            inSignature: true,
          },
          {
            type: "input",
            placeholder: "Funkcija",
            inSignature: true,
          }],
        suffix: ' (u daljnjem tekstu: Davatelj stipendije),',
        delimiter: `i`
    },
    {
        signature: 'Stipendist:',
        inputs: [{
            type: 'input',
            required: true,
            placeholder: 'Ime i prezime',
            inSignature: true,
        },
            {
                type: 'input',
                required: true,
                placeholder: 'Ulica i kućni broj',
            },
            {
                type: 'input',
                required: true,
                placeholder: 'Mjesto',
            },
            {
                type: 'input',
                required: true,
                placeholder: 'OIB',
            },
        ],
        suffix: ' (u daljnjem tekstu: Stipendist),'
    }
],

headline: 'zaključuju sljedeći',
title: 'UGOVOR O STIPENDIRANJU STUDENTA',
noArticleNumbers: false,

articles: [

    {
        title: 'PREDMET UGOVORA',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Ovim Ugovorom, ugovorne strane reguliraju svoja međusobna prava i obveze vezane uz stipendiju koju će Davatelj stipendije isplaćivati Stipendistu sukladno odredbama ovog Ugovora.',
                value: '',
            }],
    },

    {
        title: 'OBRAZOVANJE',
        mandatory: false,
        statements: [
            {
                type: 'input',
                mandatory: true,
                editable: false,
                parts: [
                    {
                        type: 'text',
                        content: 'Stipendist je student'
                    },
                    {type: 'textarea', value: '', required: true, help: 'Upišite naziv fakulteta i smjer.'},
       ],
        },
        {
       
            type: 'input',
            mandatory: true,
            editable: false,
            parts: [
            {type: 'text', content: '\r\nStipendist se na navedenom fakultetu obrazuje za'},
            {type: 'input', value: '', required: true, help: 'Upišite naziv zvanja koje će Stipendist imati nakon završetka školovanja.'},
        ]
    }
]
},
{
    title: 'UVJETI STIPENDIRANJA',
    mandatory: false,
    statements: [
        {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Stipendiranje se vrši u funkciji rješavanja i osiguravanja budućih kadrovskih potreba Davatelja stipendije te se u tom smislu Stipendist obvezuje po završenom školovanju zasnovati radni odnos s Davateljem stipendije. \r\nStipendist se obvezuje uspješno završiti akademsku godinu i dostaviti uvjerenje o upisu u narednu akademsku godinu u roku od 15 (petnaest) dana od dana upisa, kao i valjani dokument iz kojega su vidljivi položeni ispiti u akademskoj godini.\r\nStipendist ostvaruje pravo na nastavak stipendiranja u narednoj akademskoj godini studija pod uvjetom da je uspješno upisao novu akademsku godinu.\r\nUkoliko Stipendist iz bilo kojeg razloga napusti ili završi školovanje iz ovog Ugovora, dužan je o tome u roku od 15 (petnaest) dana obavijestiti Davatelja stipendije i time ovaj Ugovor automatski prestaje.\r\nIznimno od odredbe prethodnog stavka ovog članka, Stipendist može ostvariti pravo na isplatu stipendije ukoliko ne upiše školsku godinu, uz uvjet da je za to imao opravdani razlog.\r\nOpravdani razlog u smislu prethodnog stavka predstavlja teška bolest Stipendista ili drugi opravdani razlog.\r\nOsim u slučaju teške bolesti, koju je Stipendist dužan valjano dokumentirati Davatelju stipendije, postojanje opravdanog razloga u svakom pojedinom slučaju utvrditi će Davatelj stipendije diskrecijskom ocjenom, uzimajući u obzir sve relevantne okolnosti pojedinog slučaja. \r\nStipendist kao student apsolvent može primati stipendiju na temelju ovog Ugovora samo u periodu od godinu dana računajući od dana upisa posljednje godine studija (apsolventska godina). \r\nDavatelj stipendije zadržava pravo da od Stipendista tijekom trajanja ovog Ugovora traži relevantnu dokumentaciju koja se tiče uvjeta dobivanja ove stipendije te dokumentaciju vezanu uz eventualne ostale stipendije koje prima od trećih osoba.',
            value: '',
        }],
},
    {
        title: 'STIPENDIRANO RAZDOBLJE',
        mandatory: true,
        exampleContent: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Davatelj stipendije obvezuje se stipendirati Stipendista počevši od akademske godine _____/_____ (akademskom godinom smatra  se razdoblje od 10  mjeseci), za sve vrijeme u kojemu ima status studenta u redovitom školovanju.',
                value: '',
            }],
    },
    {
        title: 'IZNOS STIPENDIJE I PLAĆANJE',
        mandatory: true,
        exampleContent: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Stipendija se isplaćuje u iznosu mjesečnog obroka od 1.750,00 (slovima: tisućusedamstopedeset) kn mjesečno. \r\nIsplata će se obavljati u 10 (deset) jednakih mjesečnih obroka, počevši od listopada u godini sklapanja ovog Ugovora, s tim da se stipendije ne isplaćuju za mjesece srpanj i kolovoz. \r\nIsplata će se izvršiti do 15-og dana u mjesecu za prethodni mjesec, a na tekući ili žiro račun Stipendista. \r\nEventualne poreze i sva ostala davanja, snosi Stipendist.',
                value: '',
            }],
    },
    {
        title: 'OBVEZE STIPENDISTA',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Stipendista se obvezuje: \r\n- redovno polagati ispite te na kraju svake školske godine Davatelju stipendije dostavljati potvrdu o položenim ispitima, \r\n- da neće promijeniti fakultet ili smjer bez suglasnosti Davatelju stipendije, \r\n- da neće napuštati započeto obrazovanje iz ovog Ugovora odnosno da će zadržati status redovitog studenta u navedenom obrazovanju. \r\nStipendist je dužan roku 15 dana od dana diplomiranja dostaviti uvjerenje o diplomiranju.',
                value: '',
            },
        
        ],
    },
    {
        title: "DOSTAVLJANJE DOKUMENTACIJE",
        mandatory: false,
        statements: [
          {
            type: "choice",
            mandatory: true,
            editable: true,
            choices: [
              "Potpisom na ovom Ugovoru, Stipendist daje izjavu da ne ostvaruje stipendiju od drugih isplatitelja, a u slučaju da stipendiju ostvaruje/počne ostvarivati od drugih Isplatitelja, o isplaćenim primicima po toj osnovi od drugih isplatitelja obvezuje se dostaviti Davatelju stipendije vjerodostojne isprave (preslike) ili pisanu izjavu.",
              "Potpisom na ovom Ugovoru, Stipendist daje izjavu da ostvaruje stipendiju od drugih isplatitelja, a prema vjerodostojnim isprava (preslike) ili pisanih izjava o isplaćenim primicima po toj osnovi, a u slučaju da počne ostvarivati stipendiju i od trećih isplatitelja odnosno u slučaju promjene iznosa tako isplaćenih stipendija, o isplaćenim primicima po toj osnovi obvezuje se dostaviti Davatelju stipendije vjerodostojne isprave (preslike) ili pisanu izjavu."
            ],
            placeholder: "Odaberite ovdje te potom izmijenite po želji...",
          }]
      },
      {
        title: 'ZASTOJ U PRIMJENI UGOVORA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Ako Stipendista tijekom trajanja ovog Ugovora ode na odsluženje vojnog roka, njegova prava i obveze po osnovu ovog Ugovora miruju dok se ne vrati na fakultet. \r\nAko Stipendista započne odsluženje vojnog roka neposredno po završetku fakulteta, u roku od 5 (pet) dana po povratku sa služenja vojnog roka dužan se javiti Davatelju stipendije i biti raspoloživ za početak radnog odnosa.',
                value: '',
            }],
    },
      {
        title: 'RASKID UGOVORA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Davatelj stipendije može raskinuti ovaj Ugovor bez otkaznog roka, ako Stipendista ponavlja akademsku godinu i/ili ako ne podnese potvrdu o statusu studenta u redovitom školovanju. \r\nUkoliko Stipendist  prekrši ugovorom preuzete obveze, Davatelj stipendije ima pravo jednostrano raskinuti ovaj Ugovor bez otkaznog roka.',
                value: '',
            }],
    },
    {
        title: 'OBVEZA POVRATA ISPLAĆENIH STIPENDIJA  ',
        mandatory: false,
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Stipendista je dužan Davatelju stipendije vratiti isplaćene stipendije ako: \r\n- dođe do raskida ovog Ugovora krivnjom Stipendiste ili, \r\n- ukoliko Stipendista po završetku školovanja ne zasnuje radni odnos s Davateljom stipendije ili,\r\n- ukoliko u roku od 2 (dvije) godine nakon zasnivanja radnog odnosa s Davateljem stipendije, nastanu uvjeti za prestanak radnog odnosa skrivljeni od strane Stipendista (otkaz uslijed skrivljenog ponašanja radnika), ili \r\n- ukoliko Stipendista, u roku od 2 (dvije) godine nakon zasnivanja radnog odnosa s Davateljem stipendije pokrene postupak redovitog otkaza Ugovora o radu. \r\nNastupanjem bilo kojeg od gore navedenih uvjeta, Stipendist je dužan vratiti Davatelju stipendije isplaćene stipendije, uvećane za zakonske zatezne kamate. \r\nStipendista nema obvezu vraćanja stipendija ako mu Davatelj stipendije ne omogući zasnivanje radnog odnosa i/ili ako u međuvremenu postane radno nesposoban, a što dokazuje nalazom i mišljenjem ovlaštenog državnog tijela za obavljanje takvih vještačenja.',
                value: '',
            }],
    },
{
    title: 'MJERODAVNO PRAVO',
    mandatory: false,
    statements: [
        {
            type: 'text',
            required: true,
            mandatory: true,
            editable: false,
            content: 'Na prava i obveze ugovornih stranaka, koja nisu posebno uređena ovim Ugovorom, primjenjuju se odredbe Zakona o obveznim odnosima.',
            value: '',
        }],
},
{
    title: 'NADLEŽNOST',
    mandatory: false,
    statements: [
        {
            type: 'choice',
            mandatory: true,
            editable: false,
            choices: [
                {
                    parts: [
                        {
                            type: 'text',
                            content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Davatelja stipendije.'
                        }
                    ]
                },
                {
                    parts: [
                        {
                            type: 'text',
                            content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom za Stipendista.'
                        }
                    ]
                },
                {
                    parts: [
                        {
                            type: 'text',
                            content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u'
                        },
                        {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true},
                        ]
                }
            ],
            value: '',
        }
    ]
},
{
    title: 'PRIMJENA UGOVORA',
    mandatory: false,
    statements: [
        {
            type: 'text',
            required: false,
            mandatory: true,
            editable: true,
            content: 'Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
            value: '',
        }],
},
{
    title: 'PRIMJERCI UGOVORA',
    mandatory: false,
    statements: [
        {
            type: 'text',
            required: false,
            mandatory: true,
            editable: true,
            content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
            value: '',
        }],
  },
{
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          {
            type: "text",
            content: "U"
          },
          {
            type: "input",
            value: "",
            placeholder: "Upišite mjesto.",
            required: true,
          },
          {
            type: "text",
            content: ", dana"
          },
          {
            type: "date",
            value: new Date(),
            required: true
          },
          {
            type: "text",
            content: "godine."
          }
        ]
      },
    ]
  },
  {
    mandatory: true,
    static: true,
    type: 3,  // signatures
    statements: [],
}
],
};






// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/211_ugovor_o_stipendiranju.ts